import { Container, DotSpinnerProps } from './styles'

import React from 'react'

const Spinner: React.FC<DotSpinnerProps> = props => (
  <Container {...props} className="spinner">
    <span className="dot1"></span>
    <span className="dot2"></span>
  </Container>
)

export default Spinner
